import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export const timezoneUtils = {
  /**
   * Get the user's timezone information
   * @returns {Object} Object containing timezone name and offset
   */
  getUserTimezone: () => {
    const tz = dayjs.tz.guess();
    const offset = dayjs().tz(tz).format('Z');
    const name = tz.replace('_', ' ');
    return {
      name,
      offset,
      fullName: `${name} (UTC${offset})`,
      value: tz
    };
  },

  /**
   * Convert UTC time to local time
   * @param {string} utcTime - Time in HH:mm format
   * @returns {string} Local time in HH:mm format
   */
  utcToLocal: (utcTime: string): string => {
    if (!utcTime) return '';
    const tz = dayjs.tz.guess();
    return dayjs.utc(dayjs.utc().format('YYYY-MM-DD') + ' ' + utcTime)
      .tz(tz)
      .format('HH:mm');
  },

  /**
   * Convert local time to UTC
   * @param {string} localTime - Time in HH:mm format
   * @returns {string} UTC time in HH:mm format
   */
  localToUtc: (localTime: string): string => {
    const tz = dayjs.tz.guess();
    return dayjs.tz(
      dayjs().format('YYYY-MM-DD') + ' ' + localTime,
      tz
    ).utc().format('HH:mm');
  }
};
